import React from 'react';
import Select, { StylesConfig } from 'react-select';
import { ISelectOption } from '../ISelectOption';
import { Carte } from '../../../utils/types/Carte';

interface CarteSelectProps {
    cartes: Carte[];
    isCartesLoading: boolean;
    setSelectedNumCarte: (numero: string) => void;
}

const customStyles: StylesConfig<ISelectOption, false> = {
    control: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
        maxWidth: '100%',
    }),
    singleValue: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menu: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
    }),
    option: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};

const CarteSelect: React.FC<CarteSelectProps> = ({ cartes, isCartesLoading, setSelectedNumCarte }) => {
    const options: ISelectOption[] = cartes.map((carte) => ({
        value: carte.numero ?? '',
        label: `${carte.numero ?? '-'} - ${carte.type ?? '-'}`,
    }));

    const handleChange = (selectedOption: ISelectOption | null) => {
        setSelectedNumCarte(selectedOption ? selectedOption.value : '');
    };

    return <Select id="autoSizingSelect" options={options} onChange={handleChange} placeholder={isCartesLoading ? 'Chargement ...' : '--- Carte'} isLoading={isCartesLoading} isClearable isSearchable noOptionsMessage={() => 'Aucune carte'} styles={customStyles} classNamePrefix="react-select" menuPortalTarget={document.body} />;
};

export default CarteSelect;
